import secureApi from '../../utils/secureApi';

export interface TeamSeason {
  _id: string;
  team: string;
  tournament: string;
  tournamentSeason: string;
  ageCategory: string;
  name?: string;
  logo?: string;
}

export interface TeamRecord {
  _id: string;
  name: string;
  shortName?: string;
  teamSeasonInfo?: TeamSeason;
}

export async function listTeams({ page = 1, pageSize = 10, tournamentId, ageCategory = '', search = '', gender = '', tournamentSeason, sport }: { page?: number; pageSize?: number; tournamentId: string; ageCategory?: string; search?: string; gender?: string; tournamentSeason?: string; sport?: string }) {
  const params: any = { page, pageSize };
  
  params.tournament = tournamentId;

  if (ageCategory) {
    params.ageCategory = ageCategory;
  }

  if (search) {
    params.search = search;
  }

  if (gender) {
    params.gender = gender;
  }
  
  if (tournamentSeason) {
    params.tournamentSeason = tournamentSeason;
  }
  
  if (sport) {
    params.sport = sport;
  }
  
  const response = await secureApi.get<any>(
    '/api/v2/tournaments/admin/teams/get-all-teams',
    { params }
  );
  
  if (response && response.data && (response.data.paginatedResults || response.data.totalCount !== undefined)) {
    return response.data;
  } else if (response && (response.paginatedResults || response.totalCount !== undefined)) {
    return response;
  }
  return response;
}

export async function addTeam(payload: any, sport?: string) {
  let url = '/api/v2/tournaments/admin/teams/add';
  if (sport) {
    url += `?sport=${encodeURIComponent(sport)}`;
  }
  return await secureApi.post<any>(url, payload);
}

export async function editTeam(teamId: string, payload: any, sport?: string) {
  let url = `/api/v2/tournaments/admin/teams/edit/${teamId}`;
  if (sport) {
    url += `?sport=${encodeURIComponent(sport)}`;
  }
  return await secureApi.post<any>(url, payload);
}

export async function getTeamById(teamId: string, teamSeasonInfoId?: string, sport?: string) {
  let url = `/api/v2/tournaments/admin/teams/get-by-id/${teamId}`;
  
  // teamSeasonInfoId is part of the path (not query parameter)
  if (teamSeasonInfoId) {
    url = `${url}/${teamSeasonInfoId}`;
  }
  
  // Only add sport as query parameter with ? (always first/only query param)
  if (sport) {
    url += `?sport=${encodeURIComponent(sport)}`;
  }
  
  const response = await secureApi.get<any>(url);
  
  if (response && response.data && (response.data._id || response.data.name)) {
    return response.data;
  } else if (response && (response._id || response.name)) {
    return response;
  }
  return response;
}

export async function deleteTeam(teamId: string, sport?: string) {
  let url = `/api/v2/tournaments/admin/teams/delete/${teamId}`;
  if (sport) {
    url += `?sport=${encodeURIComponent(sport)}`;
  }
  return await secureApi.post<any>(url, {});
}

export async function fetchTeamsFromPreviousSeason(tournamentId: string, seasonId: string, ageCategory?: string, sport?: string) {
  const params: any = {};
  if (ageCategory) {
    params.ageCategory = ageCategory;
  }
  if (sport) {
    params.sport = sport;
  }
  
  const response = await secureApi.get<any>(
    `/api/v2/tournaments/admin/teams/fetch-teams-from-previous-season/${tournamentId}/${seasonId}`,
    { params }
  );
  
  let teams: any[] = [];
  if (response && response.data && Array.isArray(response.data)) {
    teams = response.data;
  } else if (Array.isArray(response)) {
    teams = response;
  } else if (response && response.data && response.data.teams && Array.isArray(response.data.teams)) {
    teams = response.data.teams;
  }
  
  return teams;
}

export async function mapTeamsFromPreviousSeason(seasonId: string, payload: { previousSeasonTeams: string[]; ageCategory: string }, sport?: string) {
  let url = `/api/v2/tournaments/admin/teams/map-from-previous-season/${seasonId}`;
  if (sport) {
    url += `?sport=${encodeURIComponent(sport)}`;
  }
  return await secureApi.post<any>(url, payload);
} 
